export default {
  home: {
    minute: 'min',
    price_info: 'First {mianfei} min free. Daily max of {currencyName}{fengding}. Your {currencyName}{yajin} deposit is only charged if your rental reaches that amount.',
    feature_1: 'Works with all phones',
    feature_2: 'Return it at any station',
    feature_3: 'Wireless charging on supported models',
    tips_1: 'Your {currencyName}{yajin} deposit is refunded as soon as you return the power bank.',
    tips_2: 'Add a {currencyName}{yajin} deposit to start renting — it’s refunded when you return the power bank.',
    tips_3: 'You have {currencyName}{myyue} in your balance — you can rent right away.',
    submit: 'Start rental',
    borrow: 'Rent',
    msg_fail_title: 'Something went wrong',
    msg_fail_content: 'Rental failed. Please try again.',
    msg_rentcount: 'You have {zujieNum} active rental(s) that aren’t closed yet.',
    goborrow: 'Start charging',
    nearby: 'Find nearby stations',
    preauth: 'Pre-authorize',
    scan: 'Scan QR',
    swipetitle1: 'Find a U Charge Up Station',
    swipemsg1: 'Use our map to find a station near you.',
    swipetitle2: 'Scan the QR Code',
    swipemsg2: 'Scan the QR code on the station to unlock your U Charge Up power bank.',
    swipetitle3: 'Charge On the Go',
    swipemsg3: 'Grab your power bank and enjoy!',
    swipetitle4: 'Return Anywhere',
    swipemsg4: 'Return your power bank to any of our stations nearby.'
  },
  login: {
    code_title: 'SMS Verification',
    phone_number: 'Phone Number',
    verification_code: 'Enter the verification code',
    captcha_code: 'Code',
    send_code: 'Send Code',
    login: 'Log In',
    agree: 'By logging in, you agree to our ',
    readme: `User Agreement`,
    msg_fail_login: 'Login failed',
    msg_success_login: 'Logged in',
    msg_fail_user: 'We couldn’t load your account. Try again?',
    sign_in_with: 'Sign in with',
    no_sms: 'Didn’t get the code?',
    retry: 'Resend',
    emaillogin: 'Use email'
  },
  confirm: {
    deletecard: 'Delete card',
    title: 'Confirm Payment',
    paynow: 'Pay now',
    SMSConfirm: 'Follow the payment instructions in the text message on your phone, then tap Confirm to continue.',
    pay_label: 'Amount',
    auth_label: 'Pre-authorization',
    pay_type: 'Payment Method',
    submit: 'Confirm Payment',
    msg_loading: 'Loading…',
    msg_fail_title: 'Heads up',
    msg_fail_payment: 'We couldn’t start the deposit payment.',
    msg_fail_order: 'We couldn’t create your rental.',
    msg_fail_support: 'This isn’t supported.',
    msg_fail_confirm: 'Confirm',
    msg_fail_retry: 'Retry',
    msg_fail_cancel: 'Cancel',
    noPhone: 'Please enter your phone number'
  },
  mine: {
    title: 'My Profile',
    wallet: 'My Wallet',
    balance: 'My Balance',
    deposit: 'Deposit',
    wallet_in: 'Add Funds',
    wallet_out: 'Withdraw',
    wallet_log: 'Wallet History',
    order: 'Orders',
    coupon: 'Coupons',
    login_tips: 'Please log in',
    msg_fail_title: 'Something went wrong',
    msg_fail_update: 'Update failed. Please try again.',
    msg_loading: 'Loading…',
    msg_fail_user: 'We couldn’t load your account. Try again?',
    help: 'Help',
    setting: 'Settings',
    logout: 'Log Out',
    buy: 'Get a Station',
    menutip1: 'Add U Charge Up to your venue',
    menutip2: 'Become a partner and put a U Charge Up station in your venue.'
  },
  msg: {
    no_phone: 'Phone number is required',
    no_email: 'Email is required',
    loading: 'Loading…',
    title: 'Heads up',
    success: 'Done',
    error: 'Something went wrong. Please try again later.',
    roleerror: 'You don’t have permission for this. Please contact an administrator.',
    neterror: 'Network connection failed. Please try again later.',
    confirm: 'Confirm',
    download: 'Download',
    retry: 'Retry',
    cancel: 'Cancel',
    title_fail: 'Heads up',
    vieworder: 'View order',
    success_payment: 'Payment complete',
    success_buy: 'Purchase complete',
    fail_payment: 'Payment failed',
    keyword: 'Keyword',
    ispayorder: 'Have you completed the payment?',
    unpay: 'Unpaid',
    yespay: 'Paid',
    notopen: 'Not open yet',
    appoffline: 'The app isn’t live yet — please hang tight.'
  },
  result: {
    title: 'Rental Confirmed',
    tips: 'Your power bank is ready — grab it and enjoy your day, stress-free!',
    gotit: 'Got It',
    price_plan: 'Pricing',
    msg_success: 'Rental Successful',
    msg_tips_loading: 'Your power bank is being released, please wait…',
    msg_result_loading: 'Confirming your payment…',
    msg_fail_confirm: 'Confirm',
    btn_usage: 'How to use',
    btn_return: 'How to return',
    deposit: 'Deposit',
    msg_fail_content: 'Request failed. Please try again.',
    price_label: 'per hour',
    price_info: 'First {mianfei} min free. Daily max of {ccurrency}{fengding}. Your {ccurrency}{yajin} deposit is only charged if your rental reaches that amount.',
    tips_1: 'Grab power bank <span class="number">No.{number}</span> as shown.',
    tips_2: 'When returning, tidy the cables and push the power bank in <span class="highlight">[arrow down]</span> until it locks.',
    msg_note_usage: 'Your power bank has 3 cable types plus wireless charging — use whichever you need.',
    msg_note_return: 'When returning, tidy the cables and push the power bank in [arrow down] until it locks.',
    return_info: 'To return, tidy the cables and slide the metal-contact side into an empty slot until it reaches the bottom and locks in place.'
  },
  result_msg: {
    loading: 'Loading…',
    refresh: 'Refresh'
  },
  order: {
    title: 'My Rentals',
    in_use: 'Active',
    ended: 'Ended',
    msg_error: 'Request failed'
  },
  order_item: {
    order_number: 'No.',
    venue_rented: 'Rented at',
    time_rented: 'Rented on',
    venue_returned: 'Returned at',
    time_returned: 'Returned on',
    charge_standard: 'Pricing',
    charge_standard_info: '{pJifei} {pCurrency} per hour (first {pMian} min free)',
    rent_occurred: 'Amount charged',
    returned: 'Returned',
    unreturned: 'Not returned',
    type_0: 'Incomplete',
    type_1: 'Renting',
    type_2: 'Canceled',
    type_3: 'Returned',
    type_4: 'Issue occurred',
    type_5: 'Overtime',
    min: 'min',
    payment: 'Payment'
  },
  setting: {
    title: 'Settings',
    lang: 'Language'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Add Funds',
    price_label: 'Amount',
    price_placeholder: 'Enter an amount',
    balance: 'Current balance',
    price_auto: 'Choose an amount',
    price_tips: 'You can withdraw your balance anytime. It may take 1–5 business days to reach your account.',
    submit: 'Submit',
    loading: 'Loading…',
    paying: 'Taking you to the payment page…',
    msg_title: 'Heads up',
    msg_fail_order: 'We couldn’t create your top-up order.',
    msg_fail_payment: 'We couldn’t start the payment.',
    msg_fail_retry: 'Retry'
  },
  wallet_out: {
    title: 'Withdraw',
    price_label: 'Withdrawal amount',
    price_placeholder: 'Enter an amount',
    balance: 'Current balance',
    balance_all: 'Withdraw all',
    deposit: 'Deposit',
    deposit_tips: 'You have an active rental. The {pyajin} deposit can’t be refunded until it’s returned.',
    submit: 'Submit',
    apply: 'Apply',
    confirm: 'Confirm',
    loading: 'Loading…',
    msg_fail_price: 'That withdrawal amount isn’t valid.',
    msg_fail_balance: 'You can’t withdraw more than your current balance.',
    msg_fail_submit: 'Please complete all fields.',
    msg_title: 'Something went wrong',
    msg_success_content: 'Your refund request was submitted.',
    confirmtitle: 'Heads up',
    confirmcontent: 'This wallet doesn’t support cash withdrawal. Please leave your contact info and we’ll refund you manually.',
    payee_name: 'Payee name',
    payee_bankcard: 'Bank card number',
    payee_phone: 'Phone',
    cancelText: 'Cancel',
    confirmText: 'Reapply'
  },
  map: {
    title: 'Nearby Stations',
    result_msg: 'No stations found nearby',
    msg_title: 'Error',
    no_support: "Sorry — your browser doesn't support location services.",
    my_position: 'My Location',
    distance: 'Distance',
    shop_time: 'Hours',
    free: 'Available',
    return: 'Open slots',
    shop_title: 'Station Details',
    address: 'Address',
    go_here: 'Get Directions',
    '在线': 'Online',
    '离线': 'Offline'
  }
}
